module.exports = __webpack_public_path__ + "img/icon-lishuyu@2x.f281263b.png";